import { Grid, Paper, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Input, LabelComp } from "../../controls";
import { Model, UseForm } from "../../hooks";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../api/actions/pos";
import { controller, endpoints } from "../../api/actions/api";
import { IsEmptyObj, MaxLength, ToFormData } from "../../hooks/Method";
import { useState } from "react";
import { useEffect } from "react";
import { Snackbar } from "../../layout";

const AddEditInventory = (props) => {
  const { t } = useTranslation();
  const { _post, _type, _data, _get, _getById, _store, _clear,
    
    // ✅ NEW
    productFromParent,
    from,

    // ✅ ADD THIS
    onSaved,
    onClose,
   } = props;
  const { InventoryMdl } = Model();

    const navigate = useNavigate();

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
  } = UseForm(InventoryMdl);
  const [prod, setProd] = useState({});
  const [barcode, setBarcode] = useState("");
  const [err, setErr] = useState();
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    type: "success",
    msg: "",
    show: false,
  });

  const validateForm = () => {
    let temp = {};
    temp.newInventory =
      values.inInventory !== "" ? "" : t("newStockRequired");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleExit = () => {
    if (onClose) {
      onClose();
    } else {
      navigate("/inventory");
    }

  }; 

  const handleSubmit = (isSaveExit = false) => {

    if ((isSaveExit || validateForm()) && values.productId) {

      setLoading(true);
      setErr("");

      const finalValues = {
        ...values,
        inInventory: values.inInventory ?? 0,
      };

      const onComplete = () => {
        setLoading(false);

        // SAVE & CLOSE
        if (isSaveExit) {
         // console.log("Closing dialog");

          if (onClose) {
            onClose();  // ✅ close inventory dialog
          } else {
            navigate("/inventory");
          }
          return;
        }

        // POS callback
        if (from === "pos") {
          // ✅ add item to cart immediately
          onSaved?.({
            type: "inventory-update",
            product: productFromParent,            
            inInventory: values.inInventory
          });
        }


        // SAVE & NEW
        resetFormControls();
        setProd({});
        setBarcode("");
        setErr("");

        setSnackbar({
          type: "success",
          show: true,
          msg: t("inventoryAddedSuccessfully"),
        });
      };

      _post(
        endpoints.Inventory,
        ToFormData(finalValues),
        null,
        onComplete,
        (err) => {

          console.log("ERROR:", err);

          const msg =
            err?.response?.data?.message ||
            err?.response?.data?.errors?.[0] ||
            err?.response?.data ||
            t("duplicateProductDetected");

          setErr(msg);

          setSnackbar({
            type: "error",
            show: true,
            msg,
          });

          setLoading(false);
        }
      );

    } else if (!values.productId) {

      setErr(
        t("noProductsAvailable")
      );
    }
  };

    const handleProdFind = (e) => {
    if (e.key !== "Enter") return;

    const rawBarcode = e.target.value;
    const trimmedBarcode = rawBarcode.trim();

    const storeIdVal = Number(_store?.id);
  
    const params = new URLSearchParams({
    barcode: trimmedBarcode,
    storeId: storeIdVal.toString(),
  });

const url =
  `${endpoints.Product}${controller.GetProductByBarcode}?${params.toString()}`;

    const onComplete = (res) => {
      if (res.status === 400) {
        setErr(t("productNotFound"));
        return;
      }

      setErr(null);
    };

    _get(url, actions.ActionType.Data, onComplete);
  };

  useEffect(() => {
    if (productFromParent) {
      setProd({ ...productFromParent, inInventory: 0 });

      setValues((v) => ({
        ...v,
        productId: productFromParent.id,
        storeId: _store.id,
        inInventory: 0   // ✅ ✅ ✅ THIS WAS MISSING
      }));

      setBarcode(productFromParent.barcode || "");
      setErr(null);
    }
  }, [productFromParent, _store.id, setValues]);


  useEffect(() => {
    return () => {
      resetFormControls();
      setProd({});
      setBarcode("");
      setErr();
      _clear({}, actions.ActionType.ClearData);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (_type === "product") {
      setProd({ ..._data, inInventory: 0 });
      setValues({
        ...values,
        productId: _data.id,
        storeId: _store.id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_data]);

  useEffect(() => {
    if (!IsEmptyObj(_data) && _data.id !== undefined) {
      const onComplete = (res) => {
        res.status === 200 &&
          setProd((x) => ({ ...x, inInventory: res.result.inInventory }));
      };

      _getById(
        endpoints.Inventory + controller.GetById,
        _data.id,
        null,
        onComplete
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_data]);

  return (
    <>
      <Paper className="mt-30 shadow-xs br-8">
        <Grid container spacing={3} className="p-20 pt-0">
          <Grid item xs={12} className="tx-center mt-20">
            <Typography variant="h5" className="fs-22 gray-color fw-5 tx-upp">
              Add Inventory
            </Typography>
            <div className="bs-bottom mx-w-80 m-auto mt-10 mb-30" />
          </Grid>
          {err && (
            <Grid item xs={12}>
              <Typography color="error">
                <span className="tx-upp fw-6">{t("errors")} :</span> {err}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12} md={6}>
            <Input
              label={t("searchByBarcode")}
              helperText={t("pressEnterAfterScanningBarcode")}
              onChange={(e) => setBarcode(e.target.value)}
              onKeyDown={handleProdFind}
              value={barcode}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input
              label={t("newStock")}
              name="inInventory"
              className="rmv-arrow"
              value={values.inInventory}
              error={errors.inInventory}
              type="number"
              onInput={(e) => (e.target.value = MaxLength(e.target.value, 10))}
              onChange={handleInpChg}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <LabelComp label={t("productId")} value={prod.id} />
          </Grid>
          <Grid item xs={12} md={10}>
            <LabelComp label={t("productName")} value={prod.name} />
          </Grid>
          <Grid item xs={12} md={4}>
            <LabelComp label={t("inStock")} value={prod.inInventory} />
          </Grid>
          <Grid item xs={12} md={4}>
            <LabelComp label={t("purchasePrice")} value={prod.purchPrice} />
          </Grid>
          <Grid item xs={12} md={4}>
            <LabelComp label={t("sellPrice")} value={prod.sellPrice} />
          </Grid>
          <Grid item xs={12}>
            <LabelComp label={t("productDetails")} value={prod.descr} />
          </Grid>
          <Grid item xs={12} className="tx-right mt-10">           
            {/* ✅ Exit */}
              <Button
                onClick={handleExit}
                color="whitesm"
                sx={{
                   minWidth: { md: "120px", xs: "100%" },
                   mr: { md: "10px", xs: "0px" },
                   mb: { xs: "10px", md: "0px" },
                 }}
                size="large"
                className="pr-10 pl-10"
              >
                {t("exit")}
              </Button>

              {/* ✅ Save (close after saving) */}
            <Button
              loading={loading}
              onClick={() => handleSubmit(true)}
              color="whitesm"
              sx={{
                minWidth: { md: "150px", xs: "100%" },
                mr: { md: "10px", xs: "0px" },
                mb: { xs: "10px", md: "0px" },
              }}
              size="large"
              className="pr-10 pl-10"
            >
              {t("saveAndClose")}
            </Button>

              {/* ✅ Save and Add Another (stay on form after saving) */}
            <Button
              loading={loading}
              onClick={() => handleSubmit(false)}
              sx={{ minWidth: { md: "230px", xs: "100%" } }}
              size="large"
            >
              {t("saveAndNew")}
            </Button>

          </Grid>
        </Grid>
      </Paper>
      <Snackbar {...{ snackbar, setSnackbar }} />
    </>
  );
};

const mapStateToProps = (state) => ({
  _data: state.pos.data,
  _type: state.pos.type,
  _store: state.pos.defStore,
  _authUser: state.pos.authUser,
});

const mapActionToProps = {
  _get: actions.get,            // ✅ ADD THIS
  _getById: actions.getById,
  _getByObj: actions.getByObj,   // ✅ ADD THIS
  _post: actions.post,
  _clear: actions.clear,
};

export default connect(mapStateToProps, mapActionToProps)(AddEditInventory);
